import React, { useState, useEffect } from 'react';
import { useActiveSectionOnScroll } from '../hooks/useActiveSectionOnScroll';
import logo from '../assets/logo volantin.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const sectionIds = ['inicio', 'quienes-somos', 'equipo', 'servicios', 'testimonios', 'blog', 'contacto'];
  const activeSection = useActiveSectionOnScroll(sectionIds);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'inicio', label: 'Inicio' },
    { id: 'quienes-somos', label: 'Quiénes Somos' },
    { id: 'equipo', label: 'Equipo' },
    { id: 'servicios', label: 'Servicios' },
    { id: 'testimonios', label: 'Testimonios' },
    { id: 'blog', label: 'Blog' },
    { id: 'contacto', label: 'Contacto' },
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/98 backdrop-blur-md shadow-lg shadow-black/5'
          : 'bg-white/90 backdrop-blur-sm'
      }`}
    >
      {/* Top accent bar */}
      <div className="h-1 bg-gradient-to-r from-secondary via-primary to-background" />

      <div className="container-custom">
        <div className="flex items-center justify-between h-16">

          {/* Logo */}
          <button
            onClick={() => scrollToSection('inicio')}
            className="flex items-center gap-2 cursor-pointer group"
            aria-label="Ir al inicio"
          >
            <img
              src={logo}
              alt="Logo Centro Volantín"
              className="w-12 h-12 object-contain group-hover:scale-105 transition-transform duration-200"
            />
            <span className="font-fredoka text-xl text-text group-hover:text-primary transition-colors duration-200">
              Centro Volantín
            </span>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`px-3 py-2 rounded-xl text-sm font-semibold transition-all duration-200 cursor-pointer ${
                  activeSection === item.id
                    ? 'text-primary bg-primary/10'
                    : 'text-text/70 hover:text-primary hover:bg-secondary/20'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:block">
            <button
              onClick={() => window.open('https://encuadrado.com/centro/centro-volantin', '_blank')}
              className="btn-primary text-sm px-5 py-2.5"
            >
              <svg className="w-4 h-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Agendar
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-xl text-text hover:bg-secondary/20 transition-colors cursor-pointer"
            aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden pb-4 pt-2 border-t border-gray-100">
            <div className="flex flex-col gap-1">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`px-4 py-3 rounded-xl font-semibold text-left transition-all duration-200 cursor-pointer ${
                    activeSection === item.id
                      ? 'text-primary bg-primary/10'
                      : 'text-text/70 hover:text-primary hover:bg-secondary/10'
                  }`}
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => window.open('https://encuadrado.com/centro/centro-volantin', '_blank')}
                className="btn-primary mt-2 text-sm"
              >
                Agendar cita
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
